import React from 'react';
import { Form, Input, Button } from 'antd';

interface ChangePasswordFormProps {
  isLoading?: boolean;
  onSubmit: (oldPassword: string, newPassword: string) => void;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  isLoading = false,
  onSubmit,
}) => {
  const handleSubmit = (values: any) => {
    onSubmit(values.currentPassword, values.password);
  };

  return (
    <Form layout="vertical" name="change-password" onFinish={handleSubmit}>
      <Form.Item
        label="Current password"
        name="currentPassword"
        rules={[
          { required: true, message: 'Please input your current password' },
        ]}
      >
        <Input.Password size="large" disabled={isLoading} />
      </Form.Item>

      <Form.Item
        label="New password"
        name="password"
        rules={[{ required: true, message: 'Please input new password' }]}
      >
        <Input.Password size="large" disabled={isLoading} />
      </Form.Item>

      <Form.Item
        label="Repeat password"
        name="confirmedPassword"
        rules={[
          { required: true, message: 'Please repeat your new password' },
          ({ getFieldValue }) => ({
            validator(rule, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                'The two passwords that you entered do not match!'
              );
            },
          }),
        ]}
      >
        <Input.Password size="large" disabled={isLoading} />
      </Form.Item>

      <Button type="primary" htmlType="submit" size="large" loading={isLoading}>
        Update
      </Button>
    </Form>
  );
};

export default ChangePasswordForm;
